/**
 * The line that admits the issue list is a slice of the board.
 *
 * A board of 2,048 issues arrives 100 at a time, and the notice's job is to say
 * so AND to name the way out. Only two filters are applied by the server —
 * `search` and `sprintId` — so only those two narrow the whole board; the
 * dimension filters run over the loaded page and cannot.
 *
 * Which means the sentence depends on the screen: the sprint picker only exists
 * on a board that has sprints. The board where this notice matters most has
 * none — Accountant's + Legal holds 2,048 issues and zero sprints — so naming
 * the picker there sent a reader hunting for a control that is not on the page.
 */
export function truncationNotice(input: {
  /** Issues actually loaded — the page. */
  loaded: number;
  /** The board's real total, from the server's `meta.total`. */
  total: number;
  /** Whether the sprint bar is on screen, which is to say whether the board has sprints. */
  hasSprintPicker: boolean;
}): string | null {
  if (input.loaded >= input.total) return null;

  const escape = input.hasSprintPicker
    ? 'Search and the sprint picker narrow the whole board'
    : 'Search narrows the whole board';

  return `Showing the first ${input.loaded} of ${input.total} issues. ${escape} — the other filters only narrow these ${input.loaded}.`;
}
